export default __webpack_public_path__ + "static/media/Awake1.c0f14c16.png";